import {
    ActionComponentCreateProps,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import AlLeasePricingRequests from 'app/requests/PharmaLeasePricing.requests'
import AlLeasePricingForm from '../AlLeasePricingForm'

const AlLeasePricingCreate = ({
    onSuccess,
}: ActionComponentCreateProps) => {
    return (
        <AlLeasePricingForm
            onSuccess={onSuccess}
            requestParam={AlLeasePricingRequests.create()}
        />
    )
}

export default AlLeasePricingCreate
